import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { TipoVeiculoService } from '../services/tipo-veiculo.service';

@Component({
	selector: 'app-tipo-veiculo',
	templateUrl: './tipo-veiculo.component.html',
	styleUrls: ['./tipo-veiculo.component.css'],
	animations: [loadingFade, modal, alert]
})
export class TipoVeiculoComponent implements OnInit {
	public loading = false;
	public tiposveiculo = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// modal
	public modalApagar = 'hidden';
	public idTipoVeiculoApagar = null;
	public nomeTipoApagar = '';

	// alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

	constructor(private tipoVeiculoSvc: TipoVeiculoService,) { }

	ngOnInit() {
		this.pegaTiposVeiculo();
	}

	pegaTiposVeiculo() {
		this.tiposveiculo = [];
		this.loading = true;
		this.tipoVeiculoSvc.getTiposVeiculo().then((data: any[]) => {
			this.tiposveiculo = data;
			this.count = this.tiposveiculo.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	perguntaApagar(id, nome) {
		this.modalApagar = 'shown';
		this.idTipoVeiculoApagar = id;
		this.nomeTipoApagar = nome;
	}

	cancelaApagar() {
		this.modalApagar = 'hidden';
	}

	apagaTipo() {
		this.modalApagar = 'hidden';
		this.loading = true;
		this.tipoVeiculoSvc.apagaTipoVeiculo(this.idTipoVeiculoApagar).then((data) => {
			this.mostraMsg('Tipo apagado com sucesso.', 'alert-success');
			this.pegaTiposVeiculo();
		}).catch((err) => {
			console.log(err);
			this.mostraMsg('Problema ao apagar tipo.', 'alert-danger');
			this.loading = false;
		});
	}

	mostraMsg(msg, classe) {
		this.msg_alerta = msg;
		this.class_alerta = classe;
		this.flag_alerta = 'shown';
		setTimeout(() => this.flag_alerta = 'hidden', 10);
	}
}
